import { ARC4U_PARTNER_NAME, ATIVOS_PARTNER_NAME, MAGALU_PARTNER_NAME } from '@libs/renegkit';
import * as sophus from '@dues/helpers/sophus';
import * as magalu from '@dues/helpers/magalu';
import * as caixa from '@dues/helpers/caixa';
import { DebtProperty, SortingDebtResult } from '@common/apis/sorting-debt/types';
import { Propriedade, SimulatedDebt } from '@common/apis/simulated-debt/types';
import { isArcIdentifier } from './btg';
import { FormattedDebt } from '@common/contexts/DebtsContext/types';

interface ApplyNameRulesArgs {
  isArc: boolean;
  isSophus: boolean;
  isMagalu: boolean;
  isAtivos: boolean;
  isCaixa: boolean;
  properties?: DebtProperty[] | Propriedade[];
}
function handleGeneralPartnerName(defaultName: string, { isArc, isSophus, isMagalu, isAtivos, isCaixa, properties }: ApplyNameRulesArgs) {
  if (isArc) {
    return ARC4U_PARTNER_NAME;
  }

  if (isMagalu) {
    return MAGALU_PARTNER_NAME;
  }

  if (isAtivos) {
    return ATIVOS_PARTNER_NAME;
  }

  if (isCaixa) {
    return caixa.capitalizeName(defaultName);
  }

  if (isSophus) {
    const safeProps = properties || [];
    return sophus.formatPartnerName(safeProps) || defaultName;
  }

  return defaultName;
}

export function formatSortingDebtsPartnerName(debt: SortingDebtResult | FormattedDebt) {
  const props = debt?.properties || [];

  const showLogoMagalu = magalu.getShouldUseMagaluBrandDebt(debt?.partner?.identifier || debt?.partner?.partnerIdentifier, debt);

  const isArc =
    props.some((prop) => prop.key === 'ARC_DEBT') || isArcIdentifier(debt?.partner?.identifier) || isArcIdentifier(debt?.partner?.partnerIdentifier);
  const isSophus = debt?.partner?.partnerIdentifier === 'sophus';
  const isAtivos = debt?.partner?.partnerIdentifier === 'ativossa';
  const isCaixa = debt?.partner?.partnerIdentifier === 'caixa';

  return handleGeneralPartnerName(debt?.partner?.name, {
    isArc,
    isMagalu: !!showLogoMagalu,
    isSophus,
    isAtivos,
    properties: debt?.properties,
    isCaixa,
  });
}

export function formatSimulatedDebtPartnerName(debt: SimulatedDebt) {
  const props = debt?.propriedades || [];
  const isArc =
    props.some((prop) => prop.chave === 'ARC_DEBT') ||
    isArcIdentifier(debt?.partner?.identifier) ||
    isArcIdentifier(debt?.partner?.partnerIdentifier);
  const isSophus = debt?.partner?.partnerIdentifier === 'sophus';
  const isAtivos = debt?.partner?.partnerIdentifier === 'ativossa';
  const isCaixa = debt?.partner?.partnerIdentifier === 'caixa';

  const showLogoMagalu = magalu.getShouldUseMagaluBrandDebt(debt?.partner?.identifier || debt?.partner?.partnerIdentifier, debt);

  return handleGeneralPartnerName(debt?.partner?.name, {
    isArc,
    isMagalu: !!showLogoMagalu,
    isSophus,
    isAtivos,
    isCaixa,
    properties: debt?.propriedades,
  });
}
